import { render, staticRenderFns } from "./itemDialogLabel.vue?vue&type=template&id=eae635a2&scoped=true&"
import script from "./itemDialogLabel.vue?vue&type=script&lang=js&"
export * from "./itemDialogLabel.vue?vue&type=script&lang=js&"
import style0 from "./itemDialogLabel.vue?vue&type=style&index=0&id=eae635a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae635a2",
  null
  
)

export default component.exports